import { SET_ERROR } from "../../constants";

const setError = (param) => ({
  type: SET_ERROR,
  payload: param,
});

export default function showError(param) {
  return (dispatch, getState) => {
    clearTimeout(window.errorTimeout);
    dispatch(setError(param));
    window.errorTimeout = setTimeout(() => {
      dispatch(setError(false));
    }, 3000);
  };
}
